import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=a7e0ab0c&"
import script from "./MFooter.vue?vue&type=script&lang=js&"
export * from "./MFooter.vue?vue&type=script&lang=js&"
import style0 from "./MFooter.vue?vue&type=style&index=0&id=a7e0ab0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports